// @owners { team: patients-team }
import { SIZES } from '@alto/design-library-tokens';
import { Card, Column, H2, Link, MdPadding, MdSpacing, Row } from '@alto/design-system';
import { capitalize } from 'lodash';
import React from 'react';
import styled from 'styled-components';

const PreviewImage = styled.img`
  display: block;
  max-height: ${SIZES.ILLUSTRATION.XXL.px};
  object-fit: contain;
  width: 100%;
`;

export type BenefitCardPhotoPreviewProps = {
  readonly disabled?: boolean;
  readonly loading?: boolean;
  readonly onDelete: () => void;
  readonly sideOfCard: 'front' | 'back';
  readonly source: string;
};

const getImageAlt = (sideOfCard: BenefitCardPhotoPreviewProps['sideOfCard']) =>
  `${capitalize(sideOfCard)} of benefits card`;

const getDeleteAccessibilityLabel = (sideOfCard: BenefitCardPhotoPreviewProps['sideOfCard']) =>
  `delete ${sideOfCard} of card`;

export const BenefitCardPhotoPreview = ({
  disabled,
  loading,
  onDelete,
  sideOfCard,
  source,
}: BenefitCardPhotoPreviewProps) => {
  const hideDelete = disabled || loading;

  return (
    <Column>
      <Row
        spaceBetween
        centerVertically
      >
        <H2>{`${capitalize(sideOfCard)} of card`}</H2>
        {!hideDelete ? (
          <Link
            accessibilityLabel={getDeleteAccessibilityLabel(sideOfCard)}
            textSize="mini"
            onPress={onDelete}
          >
            Delete
          </Link>
        ) : null}
      </Row>
      <MdSpacing />
      <Card>
        <MdPadding>
          <PreviewImage
            alt={getImageAlt(sideOfCard)}
            src={source}
          />
        </MdPadding>
      </Card>
    </Column>
  );
};
